import { roundTo2 } from "components/common/formatter";

export const COMPLETION_BALANCE_ROWS = [
  { key: "officeBalance", label: "Office balance" },
  { key: "clientBalance", label: "Client balance" },
  { key: "ddaBalance", label: "DDA balance" },
  { key: "wipBalance", label: "WIP balance" },
  { key: "duuBalance", label: "Anticipated Disbursement", spaced: true },
  { key: "unpaidBills", label: "Outstanding Allocation" },
  { key: "undertakingBalance", label: "Outstanding Undertakings" },
];

export const getNonZeroBalances = (balances) =>
  COMPLETION_BALANCE_ROWS.filter(
    (row) => roundTo2(balances?.[row.key] ?? 0) !== 0,
  );
